import { type FC } from 'react'

import { useTranslation } from 'react-i18next'
import TextareaAutosize from 'react-textarea-autosize'

import './_addPoll.scss'

interface Props {
    question: string
    handleQuestionChange: (value: string) => void
    validationError?: string
}

const ASK_QUESTION_MAX_LENGTH = 50
const ASK_ALLOWED_CHARACTERS_REGEX = /^[A-Za-z0-9 ?!,.:;)]*$/

const AskQuestion: FC<Props> = ({
    question,
    handleQuestionChange,
    validationError
}) => {
    const { t } = useTranslation()

    const handleAskQuestionChange = (value: string) => {
        if (ASK_ALLOWED_CHARACTERS_REGEX.test(value)) {
            handleQuestionChange(value)
        }
    }

    return (
        <div className='askQuestion'>
            <div className='askQuestion__header'>
                <TextareaAutosize
                    value={question}
                    name='askQuestionTitle'
                    id='askQuestionTitle'
                    placeholder={`${t('askMeAQuestion')}...`}
                    maxLength={ASK_QUESTION_MAX_LENGTH}
                    minRows={1}
                    maxRows={2}
                    onChange={e => {
                        handleAskQuestionChange(e.target.value)
                    }}
                />

                <div className='askQuestion__header__error'>
                    {validationError}
                </div>
            </div>

            <div className='askQuestion__content'>
                <div className='askQuestion__option'>
                    <div className='askQuestion__option__input'>
                        <input
                            type='text'
                            name='questionText'
                            placeholder={t('fansWillRespondHere')}
                            maxLength={25}
                            disabled
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AskQuestion